export const stripHTMLTagsAndGetParagraphs = (html: string): string[] => {
	const newLinesAdded = html.replace(/(<\/(?:p|h[1-6]|li|ul|ol)>)/gm, '$1\n');
	const stripped = sanitizeHTMLTags(newLinesAdded);
	return stripped.split(/(?:\r\n|\r|\n)+/g);
};

export const stripHTMLTags = (html: string): string =>
	html.replace(/(<([^>]+)>)/gi, '');

/**
 * Returns a string containing plain text format by removing HTML tags
 * @param html - input HTML string
 * @returns Sanitized string with HTML tags removed
 */
export const sanitizeHTMLTags = (html: string): string => {
	const doc: Document = new DOMParser().parseFromString(html, 'text/html');
	return doc.body.textContent || '';
};
